import { createStore } from '@stencil/store';

export interface IReportingToolsCommonStore {
  displayModal: boolean;
  onRecording: boolean;
  isRecording: boolean;
  displayVideoPreview: boolean;
  isImagePreview: boolean;
  recordingTime: number;
  isPrintingScreen: boolean;
}

const commonStore = createStore<IReportingToolsCommonStore>({
  displayModal: false,
  onRecording: false,
  isRecording: false,
  displayVideoPreview: false,
  isImagePreview: false,
  recordingTime: 0,
  isPrintingScreen: false,
});

export default commonStore;
